import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
.container {
    display: flex;
    justify-content: space-between;
    padding: 8px;
    padding-bottom: calc(8px * 2);
}
.screener-header {
    padding-left: 0;
    padding-right: 0;
    padding-top: calc(8px / 2);
    padding-bottom: calc(8px * 3);
}
.screener-header h1 {
    margin-top: 0;
    font-size: 48px;
}
h1 {
    margin-bottom: 8px;
    font-size: 36px;
  font-family: 'Nimbus Sans', sans-serif;
  font-weight: 400;
  font-style: normal;
    font-weight: normal;
}
.call {
  font-size: 12px;
  font-weight: 400;
  color: #111111;
}
.prospectus {
  font-size: 12px;
  font-weight: 400;
  color: #111111;
}
.call {
    margin-bottom: 8px;
}
a {
    font-size: 14px;
    font-weight: normal;
    color: #086ea1;
    text-decoration: none;
  font-family: 'Nimbus Sans', sans-serif;
  font-weight: 400;
  font-style: normal;
}
a.ph {
    color: #4c5a6a;
    text-decoration: none;
    font-size: 12px;
    font-weight: 400;
}
.right {
    align-self: flex-end;
}
.open-account-btn > a {
    color: #ffffff;
    background: #086ea1;
    border: 1px solid #086ea1;
    border-radius: 4px;
    display: inline-block;
    width: -webkit-max-content;
    width: max-content;
    font-size: 16px;
    font-family: 'Nimbus Sans Novus Bold', sans-serif;
    font-weight: 700;
    line-height: 16px;
    padding: 11px calc(8px * 2);
    margin: calc(8px * 3) 0;
}
.open-account-btn > a:hover {
    background: #07608d;
    text-decoration: underline;
}
.open-account-btn > a:focus {
    text-decoration: underline;
}
.open-account-btn > a:active {
    text-decoration: none;
    background: #065379;
}
.mobile-open-acct-container {
    display: none;
    padding: 8px;
    font-size: 12px;
    color: #898989;
    background: #f8f8f8;
}
.mobile-open-acct-container div {
    flex: 1;
}
.snapshot-mobile-open-acct {
    display: none;
    padding: 8px;
    font-size: 12px;
    color: #898989;
}
.snapshot-mobile-open-acct div {
    flex: 1;
}
.open-acct-text {
    font-size: 14px;
}
.call-now {
    text-align: right;
    font-size: 14px;
}
.resources .resource :global(a) {
    text-decoration: none;
    color: #086ea1;
}
.resources .resource {
    display: inline-block;
    font-size: 14px;
    border-left: 1px solid #c4c4c4;
    padding-right: 8px;
    padding-left: 8px;
    color: #3b3b3b;
}
.resources .resource:first-child {
    border-left: 0;
    padding-left: 0;
}
@media (max-width: 720px) {
    .resources .resource {
        display: none;
    }
    .resources .resource.mobile {
        display: block;
        padding: 8px 0 8px 0;
        border: none;
    }

    .container:not(.transparent) {
        background: #ffffff;
    }
    .desktop-open-acct-container {
        display: none;
    }

    .mobile-open-acct-container {
        display: flex;
    }
    .snapshot-mobile-open-acct {
        display: flex;
        padding: 0;
        padding-top: 8px;
    }

    .screener-header {
        padding-left: calc(8px * 2);
        padding-right: calc(8px * 2);
    }
}
`;

export default styles;